import { render, staticRenderFns } from "./CustomerPortalOrderHistory.vue?vue&type=template&id=4aefc5de&scoped=true&"
import script from "./CustomerPortalOrderHistory.vue?vue&type=script&lang=js&"
export * from "./CustomerPortalOrderHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aefc5de",
  null
  
)

export default component.exports